import PropTypes from 'prop-types';
import React from 'react';
import Lightbox from 'react-image-lightbox';
import StaffPicks from 'components/Badges/StaffPicks/StaffPicks';
import SvgIcon from 'components/SvgIcon/SvgIcon';
import styles from './ImagePlayer.module.scss';
import 'react-image-lightbox/style.css';

class ImagePlayer extends React.Component {
  static propTypes = {
    onLoad: PropTypes.func,
    onZoom: PropTypes.func,
    project: PropTypes.object.isRequired,
    staffPicks: PropTypes.bool,
    user: PropTypes.object,
    zoom: PropTypes.bool,
  };

  static defaultProps = {
    zoom: true,
  };

  constructor() {
    super();

    this.state = {
      imgLoaded: false,
      zoomed: false,
    };

    this.handleLoadImage = this.handleLoadImage.bind(this);
  }

  componentDidMount() {
    if (this.refs.hiddenImage.complete) {
      this.handleLoadImage();
    }
  }

  handleLoadImage() {
    this.setState({
      imgLoaded: true,
    });

    if (this.props.onLoad) {
      this.props.onLoad();
    }
  }

  handleZoom() {
    if (this.props.onZoom) {
      this.props.onZoom();
    }
  }

  render() {
    const { project, staffPicks, zoom, user } = this.props;
    const { imgLoaded, zoomed } = this.state;
    const { thumbnails } = project;

    const originalImage =
      thumbnails.original_optimised !== ''
        ? thumbnails.original_optimised
        : thumbnails.original;

    return (
      <div>
        <span
          itemProp="embedUrl"
          content={
            project && project.links && project.links.widget
              ? project.links.widget
              : ''
          }
        />
        <span
          itemProp="thumbnail"
          content={
            project && project.thumbnails && project.thumbnails.original
              ? project.thumbnails.original
              : ''
          }
        />
        <span
          itemProp="datePublished"
          content={project && project.created_at ? project.created_at : ''}
        />
        <span
          itemProp="author"
          content={user && user.displayname ? user.displayname : ''}
        />
        <div
          className={`${styles.imageContainer} ${zoom ? styles.zoom : ''}`}
          onClick={() => (zoom ? this.setState({ zoomed: !zoomed }) : null)}
          style={{
            backgroundColor: thumbnails.color ? thumbnails.color : '#eee',
            position: 'relative',
          }}
        >
          <div
            className={`${styles.backgroundDiv} ${
              imgLoaded ? styles.backgroundLoaded : ''
            }`}
            style={{ backgroundImage: `url('${originalImage}')` }}
          />
          <img
            alt="Twine"
            className={styles.hiddenImage}
            ref="hiddenImage"
            onLoad={() => this.handleLoadImage()}
            src={originalImage}
          />
        </div>
        {staffPicks ? (
          <StaffPicks
            project={project}
            style={{
              position: 'absolute',
              width: '20%',
              bottom: '15px',
              left: '15px',
            }}
          />
        ) : null}
        {zoom && (
          <SvgIcon
            icon="zoom"
            color="white"
            size="20"
            className={styles.zoomIcon}
          />
        )}
        {zoom && zoomed ? (
          <Lightbox
            mainSrc={originalImage}
            discourageDownloads
            onCloseRequest={() => this.setState({ zoomed: false })}
          />
        ) : null}
      </div>
    );
  }
}

export default ImagePlayer;
